/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const InboxIcon = ({ width = 24, height = 24, hidden = false, title = 'Inbox' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="2" rx=".5" ry=".5" width="24" x="6" y="4" />
    <rect height="2" rx=".5" ry=".5" width="24" x="6" y="8" />
    <rect height="2" rx=".5" ry=".5" width="24" x="6" y="12" />
    <rect height="2" rx=".5" ry=".5" width="24" x="6" y="16" />
    <path
      d="M32 10v10h-5a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H4V10H1a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
